import { render } from "./userSerial.vue?vue&type=template&id=ba51aec2&scoped=true"
import script from "./userSerial.vue?vue&type=script&lang=js"
export * from "./userSerial.vue?vue&type=script&lang=js"

import "./userSerial.vue?vue&type=style&index=0&id=ba51aec2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ba51aec2"

export default script